/**
 * SbEmpty - Wrapper around Ant Design Empty
 * 
 * Provides a consistent empty state component across the application.
 * Centralizes empty state behavior and styling.
 * 
 * @example
 * import { SbEmpty } from 'uiCore';
 * 
 * <SbEmpty description="No data available" />
 */

import React from 'react';
import { Empty } from 'antd';

const SbEmpty = ({ description = "No data", ...props }) => {
  return <Empty description={description} {...props} />;
};

export default SbEmpty;
